import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getWhatsAppLink } from '../../utils/whatsapp';
export function FinalCTA() {
  return <section className="bg-arena flex flex-col items-center justify-center text-center px-6 md:px-20 pt-[64px] md:pt-[80px] pb-[64px] md:pb-[80px]" data-id="element-203" data-mp="qae7000e64ds">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="flex flex-col items-center max-w-[720px]" data-id="element-204" data-mp="lcmfv87kmman">
        <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-8" data-id="element-205" data-mp="2jsb173nwak5">
          ¿LISTO PARA AUTOMATIZAR?
        </span>

        <h2 className="font-display text-[40px] md:text-[56px] font-bold text-carbon leading-[1.1] tracking-tightest mb-4 max-w-[680px]" data-id="element-206" data-mp="361sce3epphos">
          Tu próxima oportunidad puede estar llegando ahora.
        </h2>

        <p className="font-body text-[18px] md:text-[20px] text-carbon/55 max-w-[480px] mb-10" data-id="element-207" data-mp="33dkm3r1qozq8">
          Haz que tu empresa esté preparada para atenderla.
        </p>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3" data-id="element-208" data-mp="3875ft6wav7jm">
          <a href={getWhatsAppLink('Hola, equipo de Origen Studio. Quiero automatizar mi empresa.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-verde text-arena font-display font-semibold text-[15px] md:text-[16px] px-[32px] py-[16px] rounded-[6px] hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta active:translate-y-0 transition-all duration-200" data-id="element-209" data-mp="3d6042od1dob4">
            Quiero automatizar mi empresa{' '}
            <ArrowRight size={18} className="ml-2" data-id="element-210" data-mp="9m46mnlcrxaj" />
          </a>
          <a href={getWhatsAppLink('Hola, equipo de Origen Studio. Quiero hablar con ustedes.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-transparent text-carbon border border-carbon/20 font-display font-semibold text-[15px] md:text-[16px] px-[32px] py-[16px] rounded-[6px] hover:border-carbon/40 hover:bg-carbon/5 transition-all duration-200" data-id="element-211" data-mp="3g4fgotj76o1y">
            Hablar con ORIGEN <ArrowRight size={18} className="ml-2" data-id="element-212" data-mp="2sf3ck82q966i" />
          </a>
        </div>

        <div className="mt-16 flex flex-col items-center" data-id="element-213" data-mp="2sd0c0u3y7unj">
          <div className="w-[60px] h-px bg-carbon/15 mb-4" data-id="element-214" data-mp="374izfcz50rgx" />
          <span className="font-body text-[12px] text-carbon/30" data-id="element-215" data-mp="32dami6ylmnz0">
            Origen Studio · Colombia · 2025
          </span>
        </div>
      </motion.div>
    </section>;
}